<template>
  <TrainDetails>
    <template #dialog>
      <router-view />
    </template>
    <template #header>
      <StandardFlexBox
        @click.native="$router.push({name: location ===  'TaktPlan'?'ProjectTaktPlan':'ProjectWalletTakt'})"
        justify_content="center"
        align_content="center"
        height="100%"
        class="hover"
      >
        <v-icon>chevron_left</v-icon>
        <TText large :text="train.name" />
      </StandardFlexBox>
    </template>
    <template #body>
      <StandardFlexBox
        v-for="taktarea in taktareas"
        :key="`taktarea${taktarea.id}`"
        class="wallet-train-taktareas"
        align_content="center"
        align_items="center"
        justify_content="space-between"
        @click.native.stop="$router.push({name: `${location}TaktareaDetails`, params: {taktarea_id: taktarea.id}})"
      >
        <TText medium :text="taktarea.name" />
        <v-icon>chevron_right</v-icon>
      </StandardFlexBox>
    </template>
  </TrainDetails>
</template>
<script>

  import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'
  import TrainDetails from '@/components/ProjectWallet/TrainDetails.component.vue'
  export default {
    props: [],
    mixins: [
      TrainTaktareaDetailsMixin
    ],
    components: {
      TrainDetails,
    },
    computed: {
      taktareas(){
        return this.getUObjects({type:'taktareas', ids: this.train.taktareas});
      }
    }
  }
</script>
<style scoped>
.wallet-train-taktareas {
  height: 50px;
  border-top-color: var(--primary);
  border-top-style: solid;
  border-top-width: 1px;
  padding: 0px 5px;
  cursor: pointer;
}

.hover {
  cursor: pointer;
}
</style>
